const getSelection = (rootState) => rootState.ws.view.selection;

export default getSelection;
